import React, { useEffect } from 'react';
import { config } from '../../config';

export const Sermons = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://www.tiktok.com/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="sermons" className="section-padding bg-accent">
      <div className="container-custom">
        <div className="grid lg:grid-cols-5 gap-16 items-start">
          {/* Text Content */}
          <div className="lg:col-span-2">
            <p className="text-primary font-bold tracking-[0.3em] uppercase text-xs mb-6">Media</p>
            <h2 className="text-4xl sm:text-6xl font-bold mb-8 leading-tight">
              Watch & <br /><span className="text-primary italic font-light">Be Blessed</span>
            </h2>
            <p className="text-lg text-secondary/60 mb-12">
              Our sermons are designed to inspire, teach, and strengthen your faith. Catch up on our latest messages here.
            </p>
            
            <div className="space-y-4">
              <a href={config.socials.youtube} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 bg-white rounded-2xl border border-secondary/5 hover:shadow-lg transition-all group">
                <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center group-hover:bg-red-600 transition-colors">
                  <svg className="w-6 h-6 text-red-600 group-hover:text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-sm">YouTube Channel</h4>
                  <p className="text-xs text-secondary/40">Full service recordings</p>
                </div>
              </a>
              <a href={config.socials.tiktok} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 bg-white rounded-2xl border border-secondary/5 hover:shadow-lg transition-all group">
                <div className="w-12 h-12 bg-secondary rounded-xl flex items-center justify-center group-hover:bg-primary transition-colors">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-sm">TikTok Clips</h4>
                  <p className="text-xs text-secondary/40">Daily inspiration</p>
                </div>
              </a>
            </div>
          </div>

          {/* Featured Video */}
          <div className="lg:col-span-3">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary/10 rounded-[2.5rem] blur-2xl"></div>
              <div className="relative bg-white p-4 rounded-[2.5rem] shadow-2xl border border-secondary/5 overflow-hidden">
                <blockquote 
                  className="tiktok-embed" 
                  cite="https://www.tiktok.com/@gracetemple12/video/7596832695154609410" 
                  data-video-id="7596832695154609410" 
                  style={{ maxWidth: '100%', minWidth: '325px' }} 
                > 
                  <section> 
                    <a target="_blank" title="@gracetemple12" href="https://www.tiktok.com/@gracetemple12?refer=embed">@gracetemple12</a> 
                  </section> 
                </blockquote> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
